
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import {
    Container,
    Row,
    Col,
    FormGroup, Label
} from 'reactstrap';
import EditorComponent from "../../editor/Editor";


class HtmlImage extends Component {
    constructor(props) {
        super(props);
        this.selectFile = this.selectFile.bind(this);

        this.state = { isMounted: false };
    }
    componentDidMount() {
        this.setState({ isMounted: true });
    }
    selectFile(e) {
        let input = e.target;
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = (e) => {
                this.props.onChange({
                    type: 'image',
                    value: e.target.result
                })
            }

            reader.readAsDataURL(input.files[0]);
        }
    }

    render() {

        if (!this.state.isMounted) return null;  // Or render a loader
        return (
            <FormGroup>
                {this.props.label ? <Label>{this.props.label}</Label> : null}

                <EditorComponent

                    value={this.props.multilang ? (this.props.value && this.props.value[this.props.lang]) ? this.props.value[this.props.lang] : '' : this.props.value}
                    onChange={(val) => {

                        if (this.props.multilang) {
                            let value = this.props.value;
                            if (!value) {
                                value = {};
                            }
                            value[this.props.lang] = val;

                            this.props.onChange(value);
                        } else {

                            this.props.onChange(val);
                        }
                        this.forceUpdate();


                    }}
                />
                {this.props.error ? <p style={{marginTop: 10, color: '#dc3545', fontSize: 13}}>{this.props.error}</p> : null}

            </FormGroup>




        );
    }
}

export default HtmlImage;